import Component from "@lib/Component.js";
import CustomEventType from "@lib/helpers/CustomEventType.js";

export default class Discover extends Component {
  init() {
    super.init();
    this.addListeners();
  }

  addListeners() {
    for (let i = 0; i < this.refs.items.length; i++) {
      const element = this.refs.items[i];
      element.addEventListener("click", this);
    }
  }

  handleEvent(event) {
    if (event.type === "click" && event.currentTarget.classList.contains("video")) {
      const customEvent = new CustomEvent(CustomEventType.MODALVIDEO, {
        bubbles: true,
        detail: event.currentTarget.dataset.youtube_id
      });
      this.el.dispatchEvent(customEvent);
    }
    if (event.type === "click" && event.currentTarget.classList.contains("videoglobald")) {
      const customEvent = new CustomEvent(CustomEventType.MODALVIDEO, {
        bubbles: true,
        detail: { type: "dubicast", url: event.currentTarget.dataset.dubicast }
      });
      this.el.dispatchEvent(customEvent);
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Discover.js